/**
 * Uses the state object and returns the metric results for a range
 * of mission ids
 * @param {object} state The current redux state
 * @returns {Function}
 */
export const getMetricResultForMissions = missions => {
  let totalFlyersDistributed = 0
  let totalMetricResults = {}
  missions.forEach(mission => {
    totalFlyersDistributed += mission.totalFlyersDistributed
    mission.metricResults.nodes.forEach(metricResult => {
      const metricId = metricResult.metric.id
      if (!totalMetricResults.hasOwnProperty(metricId)) {
        totalMetricResults[metricId] = 0
        totalMetricResults[metricId + '-total'] = 0
      }
      totalMetricResults[metricId] =
        totalMetricResults[metricId] + metricResult.value
      // Sum up the total result records
      totalMetricResults[metricId + '-total'] =
        totalMetricResults[metricId + '-total'] + 1
    })
  })
  return {
    totalFlyersDistributed,
    totalMetricResults,
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/MetricResults/selectors.js